// extracted by mini-css-extract-plugin
module.exports = {"loaderwrapper":"UzraQ","black":"BXmy5","loading_spinner":"aQKeu","spin":"_dBwl"};